import { render, staticRenderFns } from "./InfrastructureDetail.vue?vue&type=template&id=1ef46b8e"
import script from "./InfrastructureDetail.vue?vue&type=script&lang=js"
export * from "./InfrastructureDetail.vue?vue&type=script&lang=js"
import style0 from "./InfrastructureDetail.vue?vue&type=style&index=0&id=1ef46b8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports